import React from 'react';
import { Banner } from './banner';
import { Axiona } from './axiona';
import { Helmet } from "react-helmet";
import { useTranslation } from 'react-i18next';

export const Patients = () => {
  const { t } = useTranslation('global');
  return (
    <>
      <Helmet>
        <title>{t('patients.helmet-title')}</title>
        <meta
          name='description'
          content='content'
        />
      </Helmet>
      <Banner />
      <Axiona />
    </>
  );
}